"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Overlay", {
  enumerable: true,
  get: function get() {
    return _Overlay.default;
  }
});

var _Overlay = _interopRequireDefault(require("./src/Overlay"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9vdmVybGF5L2luZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IGFzIE92ZXJsYXkgfSBmcm9tICcuL3NyYy9PdmVybGF5J1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/overlay/index.js
// module id = 54
// module chunks = 0